import React from 'react'
import { Button, ButtonProps } from '@/components/ui/button'
import { useBrandAware } from '@/hooks/useBrandAware'

interface BrandAwareButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'default' | 'destructive' | 'outline' | 'link'
  brandVariant?: 'primary' | 'secondary' | 'ghost'
  children: React.ReactNode
  className?: string
}

export function BrandAwareButton({ 
  variant = 'default',
  brandVariant = 'primary',
  children,
  className = '',
  ...props
}: BrandAwareButtonProps) {
  const { getBrandProps } = useBrandAware()
  const buttonProps = getBrandProps('buttons')
  
  // If brand is enabled, use brand variant
  const finalVariant = buttonProps.variant ? `brand-${brandVariant}` as any : variant
  
  return (
    <Button 
      variant={finalVariant}
      className={className}
      {...props}
    >
      {children}
    </Button>
  )
}